<template>
  <div class="foot-wrap"  @mousemove="activityAddress = null">
    <div class="enterprise-foot-info">
      <div class="enterprise-foot-info-log">
        <img
          :src="require('@/assets/home/home-top-log.png')"
          alt=""
          srcset=""
        />
      </div>
      <div class="enterprise-foot-info-content">
        <div class="enterprise-foot-project-title">产品中心</div>
        <div class="enterprise-foot-project">
          <div
            v-for="(item, index) in productCenterList"
            :key="index"
            class="enterprise-foot-project-item"
            @click="routerJump(item.router)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="enterprise-foot-info-content">
        <div class="enterprise-foot-project-title">服务与承诺</div>
        <div class="enterprise-foot-project">
          <div
            v-for="(item, index) in serviceAndPromiseList"
            :key="index"
            style="cursor: default"
            class="enterprise-foot-project-item"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="enterprise-foot-info-content">
        <div class="enterprise-foot-project-title">关于我们</div>
        <div class="enterprise-foot-project">
          <div
            v-for="(item, index) in aboutUsList"
            :key="index"
            class="enterprise-foot-project-item"
            @click="routerJump(item.router)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="enterprise-foot-info-content">
        <div @click="routerJump('/news/contactUs')" class="enterprise-foot-project-title" style="cursor: pointer;">联系我们</div>
        <div class="phone-wrap">服务热线 <span v-html="Hotline"></span></div>
        <div class="enterprise-foot-project">
          <!-- <div class="enterprise-foot-contact-item">
            <span>业务咨询：</span><span class="span-text" v-html="email"></span>
          </div>
          <div class="enterprise-foot-contact-item">
            <span>客服热线：</span><span class="span-text" v-html="Hotline"></span>
          </div>
          <div class="enterprise-foot-contact-item">
            <span>销售热线：</span><span class="span-text" v-html="salesHotline"></span>
          </div>
          <div class="enterprise-foot-contact-item">
            <span>地址：</span><span class="span-text" v-html="dezhi"></span>
          </div> -->
          <div class="address-wrap">
            <img src="@/assets/contact/map.png" alt="" class="address-map" />
            <div
              v-for="(locationItem, index) in addressList"
              :key="index"
              class="location-item"
              :style="{
                transform: `translate(${locationItem.position[0]}px, ${locationItem.position[1]}px)`,
              }"
              @mousemove.stop="activityAddress = index"
            >
              <img
                src="@/assets/contact/location.png"
                alt=""
                class="location-img"
              />
              <canvas :id="'footCanvas'+index" class="location-canvas" width="20" height="20"></canvas>
            </div>
            <div
              v-for="(ontentItem, index) in addressList"
              :key="'ontent'+index"
              v-show="activityAddress == index"
              class="address-content"
              :style="{
                transform: `translate(calc(${
                  ontentItem.position[0] - 30
                }px + 50%), calc(${ontentItem.position[1]}px - 85%))`,
              }"
              @mousemove.stop="stop()"
            >
              <div class="address-title">{{ ontentItem.title }}</div>
              <div class="address-summary">{{ ontentItem.summaryTitle }}</div>
              <div class="address-phone">{{ ontentItem.description }}</div>
            </div>
            <!-- <div class="address-content-wrap">
            </div> -->
          </div>
          <div class="enterprise-foot-contact-item">
            <div class="qrcode-wrap">
              <div>
                <div class="qrcode-app" v-html="mobileWebsite">
                  <!-- <img :src="require('@/assets/home/qrcode-app.png')" alt="" srcset="" /> -->
                </div>
                手机网站
              </div>
              <div>
                <div class="qrcode-app" v-html="WeChat">
                  <!-- <img :src="require('@/assets/home/qrcode-miniprocess.png')" alt="" srcset="" /> -->
                </div>
                微信公众号
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot-bto">
      版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;佛山市华跃计算机系统有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a
        href="https://beian.miit.gov.cn"
        target="new_frame"
        style="text-decoration: none; color: #000"
      >
        <img
          src="@/assets/foot_gxico.png"
          alt=""
          style="vertical-align: middle"
        />
        &nbsp; 备案号：粤ICP备10034934号
      </a>
    </div>
  </div>
</template>

<script>
import { getColumnChild } from "@/api/column";
import { getContentDetail, getContentList } from "@/api/content";
import { getVariableInfo } from "@/api/variable";
export default {
  name: "FootWrap",
  data() {
    return {
      productCenterList: [
        {
          title: "战略组织",
          subtitle: "适应于企业组织的定义和调整",
          router: "/strategyorganize",
        },
        {
          title: "员工管理",
          subtitle: "智能化事务处理模式 解放操作员双手",
          router: "/staffmanage",
        },
        {
          title: "考勤工时",
          subtitle: "一键式薪酬核算与薪资预算管理",
          router: "/workinghours",
        },
        {
          title: "薪酬福利",
          subtitle: "一键式薪酬核算与薪资预算管理",
          router: "/paywelfare",
        },
        {
          title: "人才招聘",
          subtitle: "建立人才储备机制，形成人才梯队管理",
          router: "/personnelrecruit",
        },
        {
          title: "人才培育",
          subtitle: "三大培训体系，赋能企业人才培养",
          router: "/personnelgrow",
        },
        {
          title: "绩效激励",
          subtitle: "与企业战略目标绑定，提高企业竞争力",
          router: "/achievementview",
        },
        {
          title: "人才发展",
          subtitle: "建立人才储备机制，形成人才梯队管理",
          router: "",
        },
      ],
      serviceAndPromiseList: [
        "5S服务",
        "3000＋实施案例",
        "HR管理讲座",
        "HR经理人沙龙",
        "7x24小时服务",
        "技术服务，历史档案",
      ],
      aboutUsList: [
        {
          title: "公司介绍",
          router: "/about/infroduction",
        },
        {
          title: "华跃商学院",
          router: "/about/business",
        },
        {
          title: "发展历程",
          router: "/about/hisory",
        },
        {
          title: "企业文化",
          router: "/about/culture",
        },
        {
          title: "华跃百科",
          router:
            "https://baike.baidu.com/item/%E4%BD%9B%E5%B1%B1%E5%B8%82%E5%8D%8E%E8%B7%83%E8%AE%A1%E7%AE%97%E6%9C%BA%E7%B3%BB%E7%BB%9F%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/51448824?fr=ge_ala",
        },
        {
          title: "华跃资讯",
          router: "/news/huayue",
        },
        {
          title: "行业资讯",
          router: "/news/industry",
        },
      ],
      activityAddress: null,
      addressList: [],
      email: "",
      Hotline: "",
      salesHotline: "",
      dezhi: "",
      mobileWebsite: "",
      WeChat: "",
    };
  },
  mounted() {
    this.getVariable();
    this.getAddressList();
  },
  methods: {
    getVariable() {
      getVariableInfo({ label: "email" }).then((res) => {
        const { result } = res;
        var doc = new DOMParser().parseFromString(result.content, "text/html");
        this.email = doc.documentElement.textContent.replace(/&nbsp;/g, " ");
      });
      getVariableInfo({ label: "Hotline" }).then((res) => {
        const { result } = res;
        var doc = new DOMParser().parseFromString(result.content, "text/html");
        this.Hotline = doc.documentElement.textContent.replace(/&nbsp;/g, " ");
      });
      getVariableInfo({ label: "salesHotline" }).then((res) => {
        const { result } = res;
        var doc = new DOMParser().parseFromString(result.content, "text/html");
        this.salesHotline = doc.documentElement.textContent.replace(
          /&nbsp;/g,
          " "
        );
      });
      getVariableInfo({ label: "dezhi" }).then((res) => {
        const { result } = res;
        var doc = new DOMParser().parseFromString(result.content, "text/html");
        this.dezhi = doc.documentElement.textContent.replace(/&nbsp;/g, " ");
      });
      getVariableInfo({ label: "mobileWebsite" }).then((res) => {
        const { result } = res;
        var doc = new DOMParser().parseFromString(result.content, "text/html");
        this.mobileWebsite = doc.documentElement.textContent.replace(
          /&nbsp;/g,
          " "
        );
      });
      getVariableInfo({ label: "WeChat" }).then((res) => {
        const { result } = res;
        var doc = new DOMParser().parseFromString(result.content, "text/html");
        this.WeChat = doc.documentElement.textContent.replace(/&nbsp;/g, " ");
      });
    },

    async getAddressList() {
      var params = { parentId: "1624978949178351616" };
      var res = await getColumnChild(params);
      var { result } = res;
      for (var i = 0; i < result.length; i++) {
        if (i === 0) {
          const data = { columnId: result[i].id, pageNum: 1, pageSize: 99 };
          getContentList(data).then(async (rrs) => {
            const rrsult = rrs.result;
            for (var j = 0; j < rrsult.data.length; j++) {
              var addressItem = {
                img: rrsult.data[j].icon,
                title: rrsult.data[j].title,
                summaryTitle: rrsult.data[j].summaryTitle,
                description: rrsult.data[j].description,
                position: [],
                radius: 0,
                ctx: null,
                canvarInterval: null,
              };
              const rts = await getContentDetail(rrsult.data[j].id);
              const rtsult = rts.result;
              for (var x = 0; x < rtsult.elements.length; x++) {
                addressItem.position.push(
                  Number(rtsult.elements[x].content) * 0.65
                );
              }
              this.addressList.push(addressItem);
            }
            this.$nextTick(()=>{
              for (var j = 0; j < this.addressList.length; j++) {
                this.setCanvas(j)
              }
            });
          });
        }
      }
    },

    setCanvas(index) {
      this.cavasIndex = index;
      this.$nextTick(() => {
        const c  = document.getElementById(`footCanvas${index}`)
        this.addressList[index].ctx = c.getContext('2d');
        this.drawCircle(index);
        this.addressList[index].canvarInterval = setInterval(() => {
          this.drawCircle(index);
        },50)
      
      })
    },
    drawCircle(index) {
      this.addressList[index].ctx.beginPath();
      let prev = this.addressList[index].ctx.globalCompositeOperation;
      this.addressList[index].ctx.globalCompositeOperation = 'destination-in';
      this.addressList[index].ctx.globalAlpha = 0.95;
      this.addressList[index].ctx.fillRect(0,0,20,20);
      this.addressList[index].ctx.globalCompositeOperation = prev;
      this.addressList[index].ctx.arc(10, 10, this.addressList[index].radius, 0, Math.PI * 2);
      this.addressList[index].ctx.closePath();
      this.addressList[index].ctx.lineWidth = 2;
      this.addressList[index].ctx.strokeStyle = 'rgba(250,98,40,1)';
      this.addressList[index].ctx.stroke();
      this.addressList[index].radius += 0.5;
      if (this.addressList[index].radius > 9) {
        this.addressList[index].radius = 0
      }
    },

    routerJump(router) {
      this.$router.push({ path: router });
    },
    stop() {}
  },
};
</script>

<style lang="less">
.enterprise-foot-contact-item {
  p {
    display: inline-block;
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>
<style lang="less" scoped>
.foot-wrap {
  background: #f7f7f7;
  .enterprise-foot-info {
    width: 70%;
    min-width: var(--minwidth);
    padding-bottom: 20px;
    padding-top: 59px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .enterprise-foot-info-log {
      img {
        width: 104px;
        height: auto;
      }
    }
    .enterprise-foot-info-content {
      margin-left: 20px;
      .enterprise-foot-project-title {
        // margin: 0 50px;
        font-size: 14px;
        font-weight: 600;
        color: #181818;
      }
      .phone-wrap {
        font-size: 14px;
        color: #31b3dc;
      }
      .enterprise-foot-project {
        display: flex;
        flex-direction: column;
        // writing-mode: vertical-lr;
        margin: 22px 0 0;
        box-sizing: border-box;
        .address-wrap {
          width: 337px;
          position: relative;
          .address-map {
            width: 100%;
            height: auto;
            display: block;
          }
          .location-item {
            position: absolute;
            top: 0;
            left: 0;
            width: 15px;
            transform-origin: center bottom;
            z-index: 1;
            cursor: pointer;
            .location-img {
              width: 100%;
              height: auto;
              display: block;
              filter: drop-shadow(4px 3px 9px rgba(1, 14, 66, 0.43));
              position: relative;
              z-index: 2;
              animation: updown 1.5s linear infinite;
            }
            @keyframes updown {
              0% {
                transform: translateY(0);
              }
              50% {
                transform: translateY(-4px);
              }
              100% {
                transform: translateY(0);
              }
            }
            .location-canvas{
              position: absolute;
              left: 50%;
              bottom: -11px;
              transform: translateX(-48%) rotateX(45deg);
              z-index: 1;
            }
          }
          .address-content {
            width: 200px;
            position: absolute;
            left: -50%;
            top: 0;
            padding: 8px;
            border: 1px solid #fff;
            border-radius: 4px;
            background: #fff;
            box-shadow: 0px 4px 8px 0px rgb(139 139 139 / 18%);
            z-index: 2;
            .address-title{
              font-family: Alibaba-PuHuiTi-R;
              font-size: 8px;
            }
            .address-summary{
              font-family: Alibaba-PuHuiTi-R;
              font-size: 10px;
              color: #3f3f3f;
            }
            .address-phone{
              font-family: Alibaba-PuHuiTi-R;
              margin-top: 6px;
              color: #00b0dc;
            }
          }
          // .address-content-wrap {
          //   width: 100%;
          //   height: 100%;
          //   position: absolute;
          //   top: 0;
          //   left: 0;
          //   z-index: 2;
          //   .address-content {
          //     width: 200px;
          //     position: absolute;
          //     left: -50%;
          //     top: -51px;
          //     padding: 8px;
          //     border: 1px solid #fff;
          //     border-radius: 4px;
          //     background: #fff;
          //     box-shadow: 0px 4px 8px 0px rgb(139 139 139 / 18%);
          //     z-index: 2;
          //   }
          // }
        }
        .enterprise-foot-project-item {
          margin-right: 59px;
          margin-bottom: 19px;
          display: inline-block;
          font-size: 14px;
          line-height: 1;
          writing-mode: lr-tb;
          vertical-align: text-bottom;
          cursor: pointer;
        }
        .enterprise-foot-contact-item {
          display: flex;
          margin-bottom: 18px;
          width: 337px;
          // writing-mode: lr-tb;
          // vertical-align: text-bottom;
          .span-text {
            flex: 1;
          }
          .qrcode-wrap {
            display: flex;
            div {
              margin: 0 20px 0 0;
            }
          }
          .qrcode-app {
            padding: 5px;
            background: #fff;
            width: fit-content;
            box-sizing: border-box;
          }
        }
      }
    }
  }
  .foot-bto {
    border-top: 1px #fff solid;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
}
</style>
